module.exports = __webpack_public_path__ + "static/media/customer-2.c086d9fc.png";